import React from "react";
import "./about.css";

export const About: React.FC = () => {
  return (
    <div className="aboutMainContainer">
      <div className="aboutLeftContent">
        <div className="title-container">
          <div className="title">About</div>
        </div>
        <div className="aboutContent">
          <div className="aboutBox">
            <div className="aboutSectionTitle">The Project</div>
          </div>
          <div className="aboutSectionInfo">
            Part of the Irving Institute&apos;s ethos is to engage with the
            larger Dartmouth community to create connections and collaborations
            with researchers in different disciplines. In the summer of 2023,
            they applied to the DALI Lab with an idea for the Energy Kiosk; an
            educational tool to display campus and regional energy data and
            promote building, campus and regional engagement goals around energy
            education. The DALI Lab accepted Irving&apos;s proposal and the
            two-term project began in Winter Term &apos;24, culminating in the
            opening of the Energy Kiosk at the end of Spring Term &apos;24.
          </div>
        </div>
        <div className="aboutContent">
          <div className="aboutBox">
            <div className="aboutSectionTitle">The DALI Team</div>
          </div>
          <div className="aboutSectionInfo">
            The DALI Lab is an innovative, startup-like experiential learning
            program where students work in teams of designers and developers to
            build digital applications to real problems. The mission of the DALI
            Lab is to &quot;
            <i>
              Elevate learning through the transformative process of building
              digital solutions from discovery to impact. We challenge ourselves
              to care — for each other, for the craft we are learning, for the
              problems we are solving, for the reality we live in, and for the
              future we envision
            </i>
            .&quot; The DALI Lab is located in the Engineering and Computer
            Science Center 002. Learn more at <u> dali.dartmouth.edu</u>.
          </div>
        </div>
        <div className="aboutContent">
          <div className="aboutBox">
            <div className="aboutSectionTitle">The Irving Institute</div>
          </div>
          <div className="aboutSectionInfo">
            The Arthur L. Irving Institute for Energy and Society was created to
            leverage Dartmouth&apos;s strengths in interdisciplinary teaching
            and learning, engineering, business, and sustainability. The mission
            of the Institute is to, &quot;
            <i>
              Advance an affordable, sustainable, and reliable energy future for
              the benefit of society. We seek to achieve this mission by
              developing the next generation of energy experts, leaders, and
              citizens and by transforming humankind&apos;s understanding of
              energy systems across technological, environmental, economic,
              geopolitical, and cultural perspectives
            </i>
            .&quot; This mission is accomplished through teaching and learning
            programs, research and collaboration initiatives and advocacy and
            outreach endeavors. To learn more, visit their website at{" "}
            <u>irving.dartmouth.edu</u>.
          </div>
        </div>
      </div>
      <div className="aboutRightContent">
        <img
          className="aboutImage"
          src="/img/GroupPhoto.jpg"
          alt="The Energy Kiosk development team"
        ></img>
        <p className="aboutPeople">
          <i>(L-R)</i>: Miruna Palaghean ‘25, Richa Ranjan GR ‘24, James
          Underwood ‘27, Nicole Ward ‘25, Cha Krupka ‘25, Sookyoung Park GR ‘24,
          Emma Yu ‘26, Alexis Loveraz ’25, Devon Starr ‘25, Selena Zhou ‘26
        </p>
      </div>
    </div>
  );
};
